import { useNavigate } from "react-router-dom";
import { useAuthActions } from "@xinosolutions/xs-auth-react";

function useReactRouterAdapter() {
  const navigate = useNavigate();
  return {
    push: (path) => navigate(path),
    replace: (path) => navigate(path, { replace: true }),
  };
}

/** XS Auth actions wired to react-router-dom (admin SPA). */
export function useAdminSignIn(options = {}) {
  return useAuthActions({
    useRouter: useReactRouterAdapter,
    ...options,
  });
}
